import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface HelpCenterLinkProps {
  link: string
  integration: string
}

const HelpCenterLink = ({ link, integration }: HelpCenterLinkProps) => {
  const { t } = useLocoTranslation()

  return (
    <a className={'primary-link'} href={link} target={'_blank'} rel={'noreferrer'}>
      <TransLoco
        t={t}
        i18nKey="dashboard.settings.payment_gateways.help_article_label"
        values={{ integration }}
      />
    </a>
  )
}

export default HelpCenterLink
